/** Query key factory: one place for cache keys so invalidation stays consistent (TanStack Query, 8.13). */
import type { MetricsQuery, RangeQuery, RankingQuery, StoreScope } from './client_endpoints';

function scopeKey(storeScope: StoreScope): string {
  return storeScope === 'all' ? 'all' : [...storeScope].sort().join(',');
}

export const queryKeys = {
  session: ['session', 'me'] as const,
  telegramConnection: ['session', 'telegram'] as const,
  stores: ['stores'] as const,
  storeTargets: (storeId: string) => ['store-targets', storeId] as const,
  metrics: (metricsQuery: MetricsQuery) =>
    [
      'metrics',
      {
        ...metricsQuery,
        stores: scopeKey(metricsQuery.stores),
        metrics: [...metricsQuery.metrics].sort().join(','),
      },
    ] as const,
  ranking: (rankingQuery: RankingQuery) => ['ranking', rankingQuery] as const,
  heatmap: (storeId: string, rangeQuery: RangeQuery) => ['heatmap', storeId, rangeQuery] as const,
  calendarHeatmap: (storeId: string, year: number) => ['calendar-heatmap', storeId, year] as const,
  tradingHours: (storeScope: StoreScope, rangeQuery: RangeQuery) =>
    ['trading-hours', scopeKey(storeScope), rangeQuery] as const,
  hourProfile: (storeScope: StoreScope, from: string, to: string, compare: string) =>
    ['hour-profile', scopeKey(storeScope), from, to, compare] as const,
  dayparts: (storeScope: StoreScope, date: string, compare: string) =>
    ['dayparts', scopeKey(storeScope), date, compare] as const,
  quality: (storeScope: StoreScope, rangeQuery: RangeQuery, withIntervals: boolean) =>
    ['quality', scopeKey(storeScope), rangeQuery, withIntervals ? 'intervals' : 'counts'] as const,
  insights: ['insights'] as const,
  alerts: ['alerts'] as const,
  alertPreferences: ['alert-preferences'] as const,
  alertChannels: ['alert-channels'] as const,
  exportJob: (exportId: string) => ['export-job', exportId] as const,
  reportTemplates: ['report-templates'] as const,
  exportList: ['export-list'] as const,
  promos: ['promos'] as const,
  holidays: (year: number) => ['holidays', year] as const,
  storeUsers: ['store-users'] as const,
  apiKeys: ['api-keys'] as const,
};
